import { render, staticRenderFns } from "./JdsPageSectionHeading.vue?vue&type=template&id=61d72502&scoped=true&"
import script from "./JdsPageSectionHeading.vue?vue&type=script&lang=ts&"
export * from "./JdsPageSectionHeading.vue?vue&type=script&lang=ts&"
import style0 from "./JdsPageSectionHeading.vue?vue&type=style&index=0&id=61d72502&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d72502",
  null
  
)

export default component.exports